import styled from 'styled-components';

export const SWrapper = styled.b`
  position: absolute;
  display: block;
  width: 160px;
  height: 160px;
  top: 50%;
  left: 50%;
  transform: translate(-52%, -50%);
  overflow: hidden;
  pointer-events: none;

  img {
    top: 0px;
    left: 0px;
    position: absolute;
    height: 160px;
    width: 1400px;
    animation: DynamiteAnim 1s steps(8) forwards;
  }

  @media (max-width: 440px) and (max-aspect-ratio: 1/1) {
    width: 85px;
    height: 85px;

    img {
      height: 85px;
      width: 745px;
      animation: DynamiteAnimMobile 1s steps(8) forwards;
    }
  }
`;
